import React, { useEffect } from "react";
import MenuPdf from "../../components/MenuPdf/MenuPdf";
import BackButton from "../../components/BackButton/BackButton";
import "../IndexPage/IndexPage.css";

function SakePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BackButton />
      <div className="sakenew-background"></div>
      <div className="card-container">
        <MenuPdf slug="sake" className="pdf-sake" alt="Sake" />
      </div>
    </div>
  );
}

export default SakePage;
